/* Shopify owns the cart. Read-only bag indicators: no VPS or cart writes. */
(()=>{'use strict';
if(!window.fetch||window.DSMCartSync)return;
const readFetch=window.fetch.bind(window);
const base=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
let running=null,timer,lastSignature='';
function publish(cart,notify=true){
 if(!cart||!Array.isArray(cart.items)||!Number.isInteger(cart.item_count)||cart.item_count<0)return;
 const n=cart.item_count;
 document.querySelectorAll('.cart-link__bubble').forEach(e=>e.classList.toggle('cart-link__bubble--visible',n>0));
 const link=document.getElementById('member-cart-open');
 if(link){
  link.dataset.cartHasItems=String(n>0);link.dataset.cartCount=String(n);
  const badge=link.querySelector('.member-bag-count');
  if(badge){badge.textContent=n?String(n):'';badge.setAttribute('aria-hidden','true');}
  const label=(link.getAttribute('aria-label')||'Your bag').replace(/\s*\(\d+\)$/,'');
  link.setAttribute('aria-label',label+' ('+n+')');
 }
 const signature=JSON.stringify([cart.items,cart.total_price,cart.currency,cart.note,cart.attributes,cart.cart_level_discount_applications]);
 const changed=signature!==lastSignature;lastSignature=signature;
 if(changed&&notify)document.dispatchEvent(new CustomEvent('disangni:gift-updated',{detail:{cart,source:'cart-state'}}));
}
function sync(){
 if(running)return running;
 running=(async()=>{
  const abort=new AbortController(),timeout=setTimeout(()=>abort.abort(),8000);
  try{
   const response=await readFetch(base+'cart.js',{method:'GET',credentials:'same-origin',cache:'no-store',signal:abort.signal});
   if(!response.ok)return null;
   const cart=await response.json();
   if(!cart||!Array.isArray(cart.items)||!Number.isInteger(cart.item_count)||cart.item_count<0)return null;
   publish(cart);return cart;
  }catch(_){return null;}finally{clearTimeout(timeout);}
 })().finally(()=>{running=null;});
 return running;
}
function schedule(){clearTimeout(timer);timer=setTimeout(sync,150);}
window.DSMCartSync={mode:'shopify-read-only',sync,ready:null};
document.addEventListener('disangni:member-cart-rendered',e=>publish(e.detail?.cart,false));
document.addEventListener('disangni:gift-updated',e=>publish(e.detail?.cart,false));
document.addEventListener('cart:updated',schedule);
document.addEventListener('ajaxProduct:added',schedule);
document.addEventListener('click',e=>{if(e.target.closest('#member-cart-open'))sync();},true);
window.addEventListener('pageshow',sync);window.addEventListener('online',sync);
document.addEventListener('visibilitychange',()=>{if(!document.hidden)sync();});
window.DSMCartSync.ready=sync();
setInterval(()=>{if(!document.hidden)sync();},30000);
})();
